import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { Location } from "@models/location";

@Injectable({providedIn: 'root'})
export class LocationClass extends AbstractClass {
  model: Location;
  modelName = 'Locations';
  idName = 'locationID';
  langBase = 'cms.components.location.';
  route = 'admin/es/settings/location';
  tableCells: TableCell[] = [
    { name: 'tenant.tenantName', label: 'tenant', cellType: 'text', order: true, download: true },
    { name: 'locationName', label: 'locationName', cellType: 'text', order: true, download: true },
    { name: 'latitude', label: 'latitude', cellType: 'text', order: true, download: true },
    { name: 'longitude', label: 'longitude', cellType: 'text', order: true, download: true }
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    { name: 'tenantID', label: 'tenant', cellType: 'tenant', disable: false, order: 1, cols: 'col-12', required: true, multiple: false, type: 'string' },
    { name: 'locationName', label: 'locationName', cellType: 'text', disable: false, order: 1, cols: 'col-12', required: true, multiple: false, type: 'string' },
    { name: 'address', label: 'address', cellType: 'text', disable: false, order: 2, cols: 'col-12', required: true, multiple: false, type: 'string' },
    { name: 'position', label: 'position', cellType: 'latlong', disable: false, order: 7, cols: 'col-12', required: false, multiple: false, type: 'number' },
    { name: 'latitude', label: 'latitude', cellType: 'latlongTxt', disable: false, order: 8, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'longitude', label: 'longitude', cellType: 'latlongTxt', disable: false, order: 9, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'reloadMap', label: 'reloadMap', cellType: 'button', disable: false, order: 9, cols: 'col-12', required: false, multiple: false, type: 'button' },
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.model = {
      locationID: 0,
      tenantID: 0,
      locationName: '',
      address: '',
      latitude: 0,
      longitude: 0,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      tenant: {
        tenantID: 0,
        tenantName: "",
        isActive: true,
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: ""
      }
    };
  }
}
